// extracted by mini-css-extract-plugin
export var resizer = "_db-0";